interface FeatureTogglingState {
    showProductReviews: boolean;
}

const DEFAULT_STATE: FeatureTogglingState = {
    showProductReviews: false,
};

export const featureToggling = (
    state = DEFAULT_STATE,
): FeatureTogglingState => {
    return state;
};